import _ from 'lodash';
import { QueryRequestParams, QueryStore, QueryStoreData, SiteSearchClickSignalRequest, SiteSearchQuerySignalRequest } from 'ui-common';
import { EmbedsFusionSearchStoreConfig } from '../services/interfaces';
import { FusionSearchDSLResultStore } from './FusionSearchDSLResultStore';

export class EmbedsFusionSearchStore extends FusionSearchDSLResultStore {
  protected config: EmbedsFusionSearchStoreConfig;
  protected initLoad: boolean = false;

  queryStore: QueryStore;

  currentParams = {
    query: '*:*',
    page: 0,
    limit: 20,
  };

  constructor(config: EmbedsFusionSearchStoreConfig) {
    super(config.queryProfileId);
    this.config = config;
  }

  /** Disabled the init load from the base MoDataStore. No need for this once it's based on MoModel. */
  override load(): Promise<any> {
    return Promise.resolve();
  }

  override subscribe(callback: (data: QueryStoreData) => void, component?: any) {
    const unSubscribe = super.subscribe(callback, component);

    if (!this.initLoad) {
      this.initLoad = true;
      this.request().then(() => this.loaded = true);
    }
  
    return unSubscribe;
  }

  override getMeta() {
    return this.cloneProps(['config', 'data', 'currentParams']);
  }

  async setQuery(query: string) {
    this.setQueryParams({ query });
    this.request();
  }

  clickSignal(request: SiteSearchClickSignalRequest) {
    return this.queryStore.clickSignal(request);
  }

  querySignal(request: SiteSearchQuerySignalRequest) {
    return this.queryStore.querySignal(request);
  }
  /**
   * Update the query params and follow up by request update if the store has loaded initially.
   */
  async setQueryParams(params: QueryRequestParams = {}, request: boolean = false) {
    this.currentParams = { ...this.currentParams, ..._.omitBy(params, _.isNil) };

    if (this.initLoad || request) {
      this.request();
    }
  }

  protected override transformDoc = (doc) => {
    const fieldMap = this.config.docFieldMap ?? {
      title: 'title_t',
      body: 'description_t',
      image: 'image_s',
      url: 'url_s',
    };

    return {
      id: doc.id,
      type: doc.type,
      rank: doc.score,
      datasourceLabels : [],
      fields: _.mapValues(fieldMap, (value, key) => doc.fields[value] || doc.fields[key]),
    };
  };

  protected override getNotificationPayload() {
    return this.data;
  }

  private updateInnerQueryStore(docs, fusionResponse) {
    const queryId = fusionResponse.meta?.debug.solrParams.fusionQueryId;

    if (!this.queryStore) {
      this.queryStore = new QueryStore({ type: this.config.type });
      this.queryStore.request = async (params?: QueryRequestParams) => (this.setQueryParams(params) as any);
      this.queryStore.getApiService = () => this.config.springboardApiService;
    }

    this.queryStore.currentParams = this.currentParams;
    this.queryStore.setQueryId(queryId);

    this.queryStore.setZoneStores({
      docs: docs.map(this.transformDoc),
      hits: fusionResponse.results?.list.hits,
      queryId,
    });
  }

  private async request() {
    const response = await this.searchDocs({
      queryParams: {
        q: this.currentParams.query,
        start: this.currentParams.limit * this.currentParams.page,
        rows: this.currentParams.limit,
      },
    });

    this.updateInnerQueryStore(response.docs, response.rawData);
    this.data = this.queryStore.meta.data;
    this.notifyUpdates();

    return response;
  }
}